import React from 'react';

const ClassificationDropdown = ({ value, onChange, classifications, disabled }) => {
  return (
    <select
      value={value || ''}
      onChange={(e) => onChange(e.target.value || null)}
      className="fc-input fc-classify-select"
      disabled={disabled}
    >
      <option value="">-- Select --</option>
      {classifications.map((c) => (
        <option key={c.code} value={c.code}>
          {c.label}
        </option>
      ))}
    </select>
  );
};

export default ClassificationDropdown;
